import * as z from "zod";

const UnpickedItemBinSchema = z.object({
  storageLocationId: z.string(),
  binName: z.string(),
  availableQuantity: z.number(),
  lastCountedAt: z.coerce.date().nullish(),
});

const UnpickedItemSchema = z.object({
  productId: z.string(),
  productTitle: z.string(),
  variantTitle: z.string().nullable(),
  sku: z.string().nullable(),
  barcode: z.string().nullable(),
  externalId: z.string(),
  requiredQuantity: z.number(),
  bins: z.array(UnpickedItemBinSchema),
});

export const UnpickedItemBinsSchema = z.object({
  items: z.array(UnpickedItemSchema),
  transitStorageLocationId: z.string().nullable(),
  transferSessionId: z.string().nullable(),
});
export type UnpickedItemBins = z.infer<typeof UnpickedItemBinsSchema>;

export const getAvailableBinsForUnpickedItems = {
  name: "getAvailableBinsForUnpickedItems" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: UnpickedItemBinsSchema,
};
